<header id="header">
  <div
    id="nuctracHeader"
    class="top-header nuctracEssentialDivider"
    [ngClass]="{
      'nuctracEssentialDivider nucracEssentialBack': nuctracEssential
    }"
    [hidden]="hideHeader"
  >
    <form class="headerForm">
      <div class="">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-2 col-lg-2">
            <div class="row">
              <div class="col col-sm-2 d-none d-sm-block d-md-none d-lg-none">
                <span class="material-icons">arrow_circle_down</span>
              </div>
              <div class="col col-sm-8">
                <div class="flex-container">
                  <h1 id="cardinal-logo" class="logo">
                    <img
                      *ngIf="!nuctracEssential"
                      class="logo-img"
                      src="../../../assets/images/CH_Nuctrac_logo.png"
                      alt="Nuctrac"
                      title="Home"
                    />
                    <img
                      *ngIf="nuctracEssential"
                      style="
                        width: 255px;
                        margin-left: -13px;
                        padding-bottom: 9px;
                      "
                      src="../../../assets/images/CH_Nuctrac_Essentials_logo.png"
                      alt="Nuctrac"
                      title="Home"
                    />
                  </h1>
                </div>
              </div>
              <div
                class="col col-sm-2 d-sm-block d-md-none d-lg-none"
                style="float: right; display: flex; justify-content: flex-end"
              >
                <span class="material-icons">logout</span>
              </div>
            </div>
          </div>
          <div
            class="col-12 col-sm-12 col-md-8 col-lg-8 user-mg-lf"
            style="align-content: end; display: grid; margin-left: 30px"
          >
            <div class="row">
              <div
                class="col-12 col-sm-12 col-md-5 col-lg-5"
                [ngClass]="{ 'col-md-6': showMobile }"
              >
                <div class="headerItem" id="account-dropdown">
                  <div class="header-text-pad">
                    <label [ngClass]="{'mobile-font-wt':isMobTab}"> Account:</label>
                  </div>
                  <ng-select
                    id="account"
                    #account
                    [items]="accountList"
                    [searchable]="false"
                    [searchFn]="searchAccountByShipTo"
                    [matTooltip]="selectedAccount?.name"
                    [matTooltipShowDelay]="1000"
                    [ngClass]="{ 'acc-max-height': (showMobile || showDeliveryAddress),'wid210': (showMobile || isMobTab || showDeliveryAddress)}"
                    style="position: relative;overflow: visible;"
                    [appendTo]="'body'"
                    class="account-div custom"
                    [(ngModel)]="selectedAccount"
                    (change)="changeAccount()"
                    [ngModelOptions]="{ standalone: true }"
                    [clearable]="false"
                    bindLabel="name"
                    [editableSearchTerm]="true"
                  >
                    <ng-template ng-header-tmp>
                      <input
                        id="accInp1"
                        label="account-search"
                        #accInp1
                        autofocus
                        style="width: 100%; line-height: 24px"
                        type="text"
                        (input)="account.filter($event.target.value)"
                      />
                    </ng-template>
                  </ng-select>
                  <div style="padding: 3px; margin-left: 8px">
                    <mat-label class="time-zone"
                      >[{{ selectedAccount?.timeZoneCode }}]</mat-label
                    >
                  </div>
                </div>
              </div>
              <div
                class="col-12 col-sm-12 col-md-4 col-lg-4"
                [ngClass]="{ 'col-md-6': (showMobile || showDeliveryAddress) }"
              >
                <div
                  class="headerItem"
                  [ngClass]="{ 'mobile-select-left-pd': showMobile }"
                  *ngIf="showMobile"
                >
                  <div class="header-text-pad">
                    <label [ngClass]="{'mobile-font-wt':isMobTab}"> Mobile:</label>
                  </div>
                  <div>
                    <ng-select
                      id="mobile"
                      #mobile
                      [items]="mobileList"
                      [searchable]="false"
                      [ngClass]="{ 'mobile-select-dropdown': showMobile }"
                      [matTooltip]="selectedAccount?.name"
                      [matTooltipShowDelay]="1000"
                      class="account-div custom zindex"
                      [(ngModel)]="selectedMobile"
                      [clearable]="false"
                      [ngModelOptions]="{ standalone: true }"
                      bindLabel="name"
                      [editableSearchTerm]="true"
                    >
                      <ng-template ng-header-tmp>
                        <input
                          autofocus
                          style="width: 100%; line-height: 24px"
                          type="text"
                          (input)="mobile.filter($event.target.value)"
                        />
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <!-- 5341 changes -->
                <div class="headerItem" [ngClass]="{ 'mobile-select-left-pd': showDeliveryAddress }" *ngIf="showDeliveryAddress">
                  <div class="header-text-pad">
                    <label [ngClass]="{'mobile-font-wt':isMobTab}"> Delivery Address:</label>
                  </div>
                  <div>
                    <ng-select id="deliveryAddress" #address [items]="deliveryAddressList" [searchable]="false"
                      [ngClass]="{ 'mobile-select-dropdown': showDeliveryAddress }" [matTooltip]="selectedAccount?.name"
                      [matTooltipShowDelay]="1000" class="account-div address-div custom" [(ngModel)]="selectedAddress" [clearable]="false"
                      [ngModelOptions]="{ standalone: true }" bindLabel="deliveryAddressText" (change)="changeAddress()">
                      <ng-template ng-header-tmp>
                        <input autofocus style="width: 100%; line-height: 24px" type="text"
                          (input)="address.filter($event.target.value)" />
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <!-- end -->
              </div>
              <div
                class="col-12 col-sm-12 col-md-3 col-lg-3 d-none d-sm-block"
                [ngClass]="{ 'd-md-none d-lg-block': (showMobile || showDeliveryAddress) }"
              >
                <div class="headerItem">
                  <label [ngClass]="{'mobile-font-wt':isMobTab}"> Pharmacy:</label>
                  <p
                    class="text headerText"
                    [matTooltip]="selectedAccount?.locName"
                    [matTooltipShowDelay]="700"
                  >
                    {{ selectedAccount?.locName }}
                  </p>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-11 col-sm-6 col-md-2 col-lg-2">
                <div class="headerItem">
                  <label [ngClass]="{'mobile-font-wt':isMobTab}"> Account No:</label>
                  <p class="text headerText">{{ selectedAccount?.shipTo }}</p>
                </div>
                <span
                  class="visible-xs-inline-block float-end-head pr-5"
                  (click)="openMobileHeader()"
                >
                  <fa-icon
                    class="fa-3x"
                    [icon]="faAngleDown"
                    *ngIf="!showMobilePanel"
                  ></fa-icon>
                  <fa-icon
                    class="fa-3x"
                    [icon]="faAngleUp"
                    *ngIf="showMobilePanel"
                  ></fa-icon>
                </span>
              </div>
              <div
                class="col-12 col-sm-12 col-md-3 col-lg-3 d-block d-sm-none"
                *ngIf="showMobilePanel"
              >
                <div class="headerItem">
                  <label [ngClass]="{'mobile-font-wt':isMobTab}"> Pharmacy:</label>
                  <p
                    class="text headerText"
                    [matTooltip]="selectedAccount?.locName"
                    [matTooltipShowDelay]="700"
                  >
                    {{ selectedAccount?.locName }}
                  </p>
                </div>
              </div>
              <div class="col-6 col-sm-6 col-md-2 col-lg-3 isItemVisible">
                <div class="headerItem tab-use-as" style="margin-left:35px"
              >
                  <mat-checkbox
                    [checked]="selectedAccount?.isDefault"
                    (change)="changeDefaultAccount(selectedAccount.isDefault)"
                    class="check-box"
                  >
                    <strong>Use as default</strong>
                  </mat-checkbox>
                </div>
              </div>
              <div class="col-11 col-sm-6 col-md-5 col-lg-4">
                <div class="headerItem ">
                  <label >Help Line Number:</label>
                  <p class="text headerText">
                    1-800-495-8832
                  </p>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-3 col-lg-3 d-none d-sm-block">
                <div class="headerItem">
                  <label [ngClass]="{'mobile-font-wt':isMobTab}"> Phone:</label>
                  <p class="text headerText">
                    {{ selectedAccount?.phoneNumber }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-12 col-md-12 col-lg-2 user-info-mr-lf">
            <div
              class="d-none d-sm-block row justify-content-lg-center justify-content-md-end justify-content-sm-end text-md-end justify-content-start user-row-pd-lf"
            >
              <div
                class="headerItem col-6"
                [ngClass]="{
                  'd-none d-sm-inline-flex d-md-inline-flex d-lg-none': (showMobile || showDeliveryAddress),
                  'd-none': !(showMobile || showDeliveryAddress)
                }"
              >
                <label [ngClass]="{'mobile-font-wt':isMobTab}"> Pharmacy:</label>

                <p
                  class="text headerText"
                  [matTooltip]="selectedAccount?.locName"
                  [matTooltipShowDelay]="700"
                >
                  {{ selectedAccount?.locName }}
                </p>
              </div>
              <div class="headerItem col-6 user-header-item">
                <label [ngClass]="{'mobile-font-wt':isMobTab}"> User:</label>
                <span
                  class="user-style desktop-mg-bt-5"
                  style="margin-left: 3px"
                  >{{ loggedInUser | uppercase }}</span
                >
                <span
                  style="cursor: pointer"
                  class="material-icons desktop-mg-bt-5"
                  [matMenuTriggerFor]="menu"
                >
                  arrow_drop_down
                </span>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="changeSecurityQuestion()">
                    Security Question
                  </button>
                </mat-menu>
              </div>
            </div>
            <div
              class="d-block d-sm-block d-sm-block row justify-content-lg-center justify-content-md-end justify-content-sm-end justify-content-start user-row-pd-lf"
              *ngIf="showMobilePanel"
            >
              <div
                class="headerItem user-header-item"
                style="display: flex; align-items: center"
              >
                <label [ngClass]="{'mobile-font-wt':isMobTab}"> User:</label>
                <span
                  class="user-style desktop-mg-bt-5"
                  style="margin-left: 3px"
                  >{{ loggedInUser | uppercase }}</span
                >
                <span
                  style="cursor: pointer"
                  class="material-icons desktop-mg-bt-5"
                  [matMenuTriggerFor]="menu"
                >
                  arrow_drop_down
                </span>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="changeSecurityQuestion()">
                    Security Question
                  </button>
                </mat-menu>
              </div>
              <div
                class="d-block d-sm-none mobile-pd-lf-0"
                *ngIf="showMobilePanel"
              >
                <div class="headerItem mobile-pd-lf-0">
                  <label [ngClass]="{'mobile-font-wt':isMobTab}"> Phone:</label>
                  <p class="text headerText">
                    {{ selectedAccount?.phoneNumber }}
                  </p>
                </div>
              </div>
            </div>

            <div
              class="row d-none d-sm-block justify-content-lg-center justify-content-md-end justify-content-sm-end justify-content-end text-md-end text-md-end logout-pd-rt"
            >
              <div class="headerItem">
                <button
                  style="width: fit-content"
                  mat-stroked-button
                  class="condensed-btn"
                  (click)="logOut('user')"
                >
                  LOG OUT
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- NUTRAC SUB HEADER -->

  <div class="bottom-header">
    <div class="row" [ngStyle]="{'padding-top': type == 'dayboard' ? '5px' : '11px'}">
      <div
        class="col-12 col-md-4 col-lg-6 d-none d-lg-block d-sm-none d-md-block"
      >
        <div style="display: flex">
          <div style="display: flex" class="sub_header_timezone" [ngClass]="{'sub-header-timezone-other-view': type != 'dayboard'}">
            <span
              *ngIf="!hideHeader"
              type="button"
              class="material-icons"
              (click)="collapseHeader()"
              style="margin-left: 2px; cursor: pointer; color: slategrey"
              matTooltip="Hide Header"
              [matTooltipShowDelay]="700"
              >arrow_circle_up</span
            >
            <span
              *ngIf="hideHeader"
              type="button"
              class="material-icons"
              (click)="collapseHeader()"
              style="margin-left: 2px; cursor: pointer; color: slategrey"
              matTooltip="Show Header"
              [matTooltipShowDelay]="700"
              >arrow_circle_down</span
            >
            <strong *ngIf="showHeaderClockFlag" style="margin-left: 10px; padding: 2px;white-space: nowrap;"
              >{{ currentTime }} {{ selectedAccount?.timeZoneCode }}
            </strong>
          </div>

          <div *ngIf="hideHeader"  id="hide-account-dropdown" [ngClass]="{account_placement:rejectedCount > 0 }">
            <div class="header-text-pad">
              <label> Account:</label>
            </div>
            <ng-select
              id="hideHeadAccount"
              #account
              [items]="accountList"
              [searchable]="false"
              [searchFn]="searchAccountByShipTo"
              [matTooltip]="selectedAccount?.name"
              [matTooltipShowDelay]="1000"
              [ngClass]="{ 'acc-max-height2': (showMobile || showDeliveryAddress) }"
              style="position: relative;overflow: visible;"
              [appendTo]="'body'"
              class="account-div custom"
              [(ngModel)]="selectedAccount"
              (change)="changeAccount()"
              [ngModelOptions]="{ standalone: true }"
              [clearable]="false"
              bindLabel="name"
              [editableSearchTerm]="true"
            >
              <ng-template ng-header-tmp>
                <input
                  id="accInp1"
                  label="account-search"
                  #accInp1
                  autofocus
                  style="width: 100%; line-height: 24px"
                  type="text"
                  (input)="account.filter($event.target.value)"
                />
              </ng-template>
            </ng-select>
            <div class="timeZone">
              <mat-label class="time-zone"
                >[{{ selectedAccount?.timeZoneCode }}]</mat-label
              >
            </div>
          </div>

          <div class="rejected_dropdown_div">
            <div
              class="col-12 col-md-1 col-lg-1 d-block d-sm-block d-sm-block d-md-block reject-req-msg"
              *ngIf="rejectedCount > 0" [ngClass]="{'tab-reject-req-msg' : rejectedCount > 0}"
            >
              <div style="display: inline-flex">
                <fa-icon
                class="red cur-pntr"
                [icon]="faExclamationCircle"
              >
              </fa-icon>
                <div [ngClass]="{'tab-refresh-span' : rejectedCount > 0}">
                  <span [ngClass]="{'tab-refresh-btn' : rejectedCount > 0}" class="refreshBtn">
                    You have {{ rejectedCount }}
                    rejected request notifications.
                  </span>
                </div>
                <div>
                  <button
                  *ngIf="!showNewRejectNotification"
                    mat-stroked-button
                    class="condensed-btn"
                    (click)="openRequest()"
                  >
                    View Details
                  </button>
                  <button
                  *ngIf="showNewRejectNotification"
                    mat-stroked-button
                    class="condensed-btn"
                    (click)="openRejectNotificationDialog()"
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div> 
          </div>
         
              
        </div>
      </div>

      <div
        class="col-12 col-md-2 col-lg-1 d-none d-sm-block d-sm-none d-md-block text-end"
      >
        <button 
          *ngIf="refreshBtn && type == 'dayboard'"
          mat-stroked-button
          class="refresh-btn condensed-btn"
          title="Refresh Button"
          (click)="refresh()"
          [matTooltipShowDelay]="700"
        >
          Refresh
        </button>
      </div>

      <div
        class="col-12 col-md-1 col-lg-1 d-none d-sm-block d-sm-none d-md-block"        
      >
        <button
          *ngIf="showToday && type == 'dayboard'"
          (click)="showTodayData()"
          mat-stroked-button
          class="today-btn condensed-btn"
        >
          Today
        </button>
      </div>

      <div class="col-12 col-md-1 col-lg-1 d-none d-sm-none d-md-block">
        <button *ngIf="type == 'dayboard'"
          mat-stroked-button
          class="d-none d-sm-none d-md-none d-lg-block report-btn condensed-btn"
          title="Click to View EOD Report"
          (click)="showEODReport()"
          [ngClass]="{'disable-EOD':disableControl}"
          style="width:106px;"
        >
          EOD Report
        </button>
      </div>

      <div
        class="col-12 col-sm-12 col-md-4 col-lg-3 tablet-pd-lf-25"
        style="align-self: center; padding-left: 50px"
        *ngIf="type === 'dayboard'"
      >
          <img
            style="cursor: pointer"
            src="assets/images/caret_left.svg"
            alt=""
            (click)="changeDate(-1)"
          />
          <span style="margin-left: 5px; margin-right: 5px;">
            <span  class="dayBoardDayfeild" >{{dayBoardDate | date :'EEEE'}}</span> 
            <input style="width:40% !important; font-size: 14px"
              class="header-date-picker"
              disabled="true"
              [(ngModel)]="dayBoardDate"
              type="text"
              readonly
            />
          </span>
          <img
            style="cursor: pointer"
            src="assets/images/caret_right.svg"
            alt=""
            (click)="changeDate(1)"
          />
          <input
            style="visibility: hidden; width: 0px"
            [matDatepicker]="picker"
            [(ngModel)]="dayBoardDate"
            (dateChange)="dateChange(dayBoardDate)"
          />
          <mat-datepicker-toggle
            style="display: none"
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <img
            style="cursor: pointer; width: 20px"
            src="assets/images/calendar_icon.svg"
            alt=""
            (click)="picker.open()"
          />
      </div>

      <div
        class="col-12 col-sm-12 col-md-4 col-lg-3 tablet-pd-lf-25 assay-dose-date-container"        
        *ngIf="type === 'assay-dose'">
        <span  class="dayBoardDayfeild" >{{dayBoardDate | date :'EEEE'}}</span> 
        <span class="assay-dose-date">{{dayBoardDate | date :'MMMM d, y'}}</span>
      </div>

    </div>
  </div>
</header>
